import React from 'react'
import { useTranslation } from 'react-i18next'
import { clearMockMode, isDemoMode } from '../config'

/**
 * Banner displayed when the application is in demo/mock mode
 * Shows a warning that data is fictional and provides option to exit demo mode
 */
export const DemoBanner: React.FC = () => {
  const { t } = useTranslation('common')

  if (!isDemoMode()) {
    return null
  }

  return (
    <div className="demo-banner">
      <div className="demo-banner-content">
        <span className="demo-banner-icon">⚠️</span>
        <span className="demo-banner-text">
          <strong>{t('demoMode.title')}</strong> - {t('demoMode.description')}
        </span>
        <button
          className="demo-banner-close"
          onClick={clearMockMode}
          aria-label={t('demoMode.exit')}
          title={t('demoMode.exit')}
        >
          ✕
        </button>
      </div>
    </div>
  )
}

export default DemoBanner
